// extracted by mini-css-extract-plugin
export const root = "carousel-figure-module--root--2OrV1";